const REQUEST_BASE_URL = '/ECMv6/rule-recommendations';

export const ERROR_MESSAGE = 'Service unavailable. Please try again later.';

export const OPERATORS_WITH_NO_VALIDATION = ['IS NULL', 'IS NOT NULL'];

export const DISABLE_CACHE_STALE_TIME = 0 as const;

export const RULE_TYPE = '1';

export const COLORS = [
  '#006BB5',
  '#A800E0',
  '#C20181',
  '#CA002F',
  '#007579',
  '#007643',
  '#B03F00',
  '#A36A00',
  '#0294F7',
  '#D057FF',
  '#FC3DA6',
  '#FF4451',
  '#00A3A9',
  '#01AE66',
  '#F25A00',
  '#E19701',
  '#9AC2FE',
  '#E9A8FF',
  '#FFA4D2',
  '#FFA7A0',
  '#28D8DF',
  '#53E596',
  '#FFA97F',
  '#FFC156',
];

export default REQUEST_BASE_URL;
